import $ from 'jQuery';

const $window = $(window);

var scrollBarWidth;
function getScrollBarWidth() {
    scrollBarWidth = window.innerWidth - $(document).width();
}

function handleNoScroll() {
    $('html').addClass('noscroll');
    $('html, .cookies__bar').css('padding-right', scrollBarWidth + 'px');
    let headerPadding = parseFloat($('.header').css('padding-right')) + scrollBarWidth;
    $('.header').css('padding-right', headerPadding + 'px');
}

function handleScroll() {
    $('html').removeClass('noscroll');
    $('html, .cookies__bar, .header').css('padding-right', '');
}

$(function () {
    getScrollBarWidth();
    $window.on('html:noscroll', handleNoScroll);
    $window.on('html:scroll', handleScroll);
});
